import { PATH_KEYS } from "../services/appServices";
import { useItemsCrud } from "./useItemsCrud";
import { useItemService } from "./useServices";
import { LawTerm } from "@/models/law-term/LawTerm";
import { useQuery } from "@tanstack/react-query";
import { restError } from "@/models/client/RestResponse";

const useLawTerms = () => {
  /**** Services ****/
  const lawTermService = useItemService((services) => services.lawTerm);

  const lawTermCrud = useItemsCrud<LawTerm>(
    [PATH_KEYS.lawTerm],
    (services) => services.lawTerm
  );

  /**** Queries & Mutations ****/
  const useQueryLawTermByLetter = (letter: string, search?: string) =>
    useQuery<LawTerm[]>({
      queryKey: [PATH_KEYS.lawTerm, "letter", letter, search],
      queryFn: async () => {
        const fetchedPageContent = await lawTermService.getLawTermByLetter(
          letter,
          search
        );
        if (fetchedPageContent.success) {
          return fetchedPageContent.value;
        } else throw restError(fetchedPageContent);
      },
    });

  const useQueryAllLawTerms = () =>
    useQuery<LawTerm[]>({
      queryKey: [PATH_KEYS.lawTerm],
      queryFn: async () => {
        const fetchedPageContent = await lawTermService.getAllLawTerms();
        if (fetchedPageContent.success) {
          return fetchedPageContent.value;
        } else throw restError(fetchedPageContent);
      },
    });

  /**** Value ****/
  return {
    ...lawTermCrud,
    useQueryLawTermByLetter,
    useQueryAllLawTerms,
  };
};

export default useLawTerms;
